import { render, staticRenderFns } from "./LandPageSearch.vue?vue&type=template&id=b89cfe94&scoped=true"
import script from "./LandPageSearch.vue?vue&type=script&lang=js"
export * from "./LandPageSearch.vue?vue&type=script&lang=js"
import style0 from "./LandPageSearch.vue?vue&type=style&index=0&id=b89cfe94&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b89cfe94",
  null
  
)

export default component.exports